const AU_POSTCODE_RANGES: Record<string, [number, number][]> = {
	act: [
		[200, 299],
		[2600, 2618],
		[2900, 2920],
	],
	nsw: [
		[1000, 2599],
		[2619, 2899],
		[2921, 2999],
	],
	nt: [[800, 999]],
	qld: [
		[4000, 4999],
		[9000, 9999],
	],
	sa: [[5000, 5999]],
	tas: [[7000, 7999]],
	vic: [
		[3000, 3999],
		[8000, 8999],
	],
	wa: [
		[6000, 6797],
		[6800, 6999],
	],
};

export function isPostcodeInState(postcode: string | number, stateId: string): boolean {
	const normalized = String(postcode).trim();
	const ranges = AU_POSTCODE_RANGES[stateId?.toLowerCase()];

	if (!/^\d{4}$/.test(normalized) || !ranges) {
		return false;
	}

	const code = Number(normalized);

	return ranges.some(([min, max]) => code >= min && code <= max);
}
